import { render, staticRenderFns } from "./ZFooter.vue?vue&type=template&id=378a1a64&scoped=true&"
import script from "./ZFooter.vue?vue&type=script&lang=js&"
export * from "./ZFooter.vue?vue&type=script&lang=js&"
import style0 from "./ZFooter.vue?vue&type=style&index=0&id=378a1a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378a1a64",
  null
  
)

export default component.exports